<template>
  <!-- 主题活动模板 -->
  <div class="themeTem">
    <!-- 面包屑导航 -->
    <crumbs-bar
      @refresh="handleRefresh"
      :crumbsList="['模板管理', $route.meta.title]"
    >
      <template slot="controls">
        <el-button
          type="danger"
          @click="delDettle"
          :disabled="selectedList.length == 0"
          icon="el-icon-delete"
          >批量删除</el-button
        >
        <el-button
          type="primary"
          icon="el-icon-circle-plus-outline"
          @click="handleAdd(false)"
          >添加模板</el-button
        >
      </template>
    </crumbs-bar>
    <!-- 搜索框 -->
    <search-bar>
      <template>
        <label class="label">状态：</label>
        <el-select
          placeholder="模板状态"
          v-model="searchForm.status"
          style="width: 100px; margin-right: 5px"
        >
          <el-option
            v-for="(item, index) in options"
            :key="index"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
        <el-input
          v-model="searchForm.name"
          style="width: 200px; margin-right: 5px"
          clearable
          placeholder="活动名称"
        ></el-input>
        <el-button type="primary" @click="seach" icon="el-icon-search"
          >搜索</el-button
        >
      </template>
    </search-bar>
    <!-- 数据展示 -->
    <el-table
      :data="tableData"
      stripe
      border
      height="calc(100% - 130px)"
      tooltip-effect="dark"
      @selection-change="selectionChange"
      style="width: 100%"
    >
      <el-table-column
        align="center"
        prop="index"
        show-overflow-tooltip
        label="序号"
      >
        <template slot-scope="scope">
          <span>{{ (currPage - 1) * pageSize + scope.$index + 1 }}</span>
        </template>
      </el-table-column>
      <el-table-column type="selection" align="center" width="55">
      </el-table-column>
      <el-table-column
        align="center"
        prop="TemplateCode"
        show-overflow-tooltip
        label="模板编号"
      >
      </el-table-column>
      <el-table-column
        prop="TemplateName"
        align="center"
        show-overflow-tooltip
        label="模板"
      >
      </el-table-column>
      <el-table-column
        prop="Status"
        label="状态"
        align="center"
        show-overflow-tooltip
      >
        <template slot-scope="scope">
          <el-tag type="warning" v-if="scope.row.Status === '0'">未上架</el-tag>
          <el-tag type="success" v-if="scope.row.Status === '1'">已上架</el-tag>
        </template>
      </el-table-column>
      <el-table-column label="操作" align="center">
        <template slot-scope="scope">
          <div v-if="scope.row.Status == 0">
            <el-button
              type="success"
              @click="changeStatus(scope.row, 1)"
              style="padding: 2px 3px"
              plain
              >上架</el-button
            >
            <el-button
              type="primary"
              @click="handleAdd(scope.row)"
              style="padding: 2px 3px"
              plain
              >编辑</el-button
            >
          </div>
          <el-button
            type="warning"
            @click="changeStatus(scope.row, 0)"
            v-else
            style="padding: 2px 3px"
            plain
            >下架</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页 -->
    <pagination
      :allPage="allPage"
      :pageSize="pageSize"
      :currIndex="currPage"
      @hanSiChange="hanSiChange"
      @hanCurrChange="hanCurrChange"
    ></pagination>
  </div>
</template>

<script>
export default {
  name: "themeTem",
  data() {
    return {
      /**表格数据 */
      //序号	模板编号	模板	状态	操作
      tableData: [
        {
          temNum: "模板编号",
          tem: "模板",
          status: "状态",
        },
      ],
      options: [
        {
          value: "9",
          label: "全部",
        },
        {
          value: "0",
          label: "未上架",
        },
        {
          value: "1",
          label: "已上架",
        },
      ],
      /**分页数据 */
      currPage: 1,
      pageSize: 20,
      allPage: 0,
      selectedList: [] /**存放选中的数据 */,
      /**搜索表单 */
      searchForm: {
        status: "9",
        name: "",
      },
    };
  },
  components: {},
  mounted() {
    this.getTableData();
  },
  methods: {
    updata() {
      this.getTableData();
    },
    seach() {
      this.getTableData(1);
    },
    /**获取表格数据 */
    getTableData(num) {
      this.currPage = num == 1 ? 1 : this.currPage;
      let json = encodeURIComponent(
        JSON.stringify({
          type: "TemplateLIst",
        })
      );
      let data = {
        type: "TemplateLIst",
        status: this.searchForm.status,
        json: json,
        proc: "",
        strWhere: this.searchForm.name,
        PageIndex: this.currPage,
        PageSize: this.pageSize,
      };
      this.$request({
        method: "post",
        url: "Admin/Template/ashx/ReturnJson.ashx",
        data: data,
      }).then((res) => {
        this.tableData = [];
        if (res.flag == 0) {
          this.tableData = res.data;
        }
      });
    },
    /**分页size改变 */
    hanSiChange(val) {
      this.pageSize = val;
      this.getTableData();
    },
    /**当前页改变 */
    hanCurrChange(val) {
      this.currPage = val;
      this.getTableData();
    },
    /**刷新表格数据 */
    handleRefresh() {
      this.getTableData();
    },
    selectionChange(section) {
      //存放选中的表格数据
      this.selectedList = section;
    },
    // 上下架
    changeStatus(row, status) {
      let msg = "确定要执行操作吗?";
      let msgType = "info";
      if (status == 1) {
        msg = "确定上架吗?";
        msgType = "success";
      } else if (status == 0) {
        msg = "确定下架吗?";
        msgType = "warning";
      }
      this.$confirm(msg, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: msgType,
      })
        .then(() => {
          let type = "AuditTemplate";
          this.$requestSys({
            method: "post",
            url:
              "Template/ashx/ReturnJson.ashx?type=" +
              type +
              "&id=" +
              row.TemplateCode +
              "&status=" +
              status,
            dataType: "json",
          })
            .then((res) => {
              if (res.flag == 0) {
                this.$message({
                  message: "操作成功",
                  type: "success",
                });
                this.getTableData();
              } else {
                this.$message({
                  message: res.message,
                  type: "error",
                });
              }
            })
            .catch((err) => {
              window.console.log(err);
            });
        })
        .catch(() => {});
    },
    // 选中数据删除
    delDettle() {
      let list = [];
      this.selectedList.forEach((item) => {
        list.push(item.TemplateCode);
      });
      this.$confirm("确定删除吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "error",
      })
        .then(() => {
          this.$requestSys({
            method: "post",
            url:
              "Template/ashx/ReturnJson.ashx?type=TemDel&strWhere=" +
              list.join(),
            dataType: "json",
          })
            .then((res) => {
              if (res.flag == 0) {
                this.$message({
                  message: "操作成功",
                  type: "success",
                });
                this.getTableData();
              } else {
                this.$message({
                  message: res.message,
                  type: "error",
                });
              }
            })
            .catch((err) => {
              window.console.log(err);
            });
        })
        .catch(() => {});
    },
    /**点击新增/编辑 */
    handleAdd(row) {
      let prams = encodeURIComponent(JSON.stringify({ id: row.TemplateCode }));
      this.$router.push({
        path: "addTemplate",
        query: {
          prams: prams,
        },
      });
    },
  },
};
</script>

<style scoped>
.themeTem {
  width: 100%;
  height: 100%;
}
</style>
